module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-c1130112.png";